import { render } from "./Egresos.vue?vue&type=template&id=631ddcfb&scoped=true"
import script from "./Egresos.vue?vue&type=script&lang=js"
export * from "./Egresos.vue?vue&type=script&lang=js"

import "./Egresos.vue?vue&type=style&index=0&id=631ddcfb&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631ddcfb"]])

export default __exports__